import { createContext } from 'react'

/**
 * The words a control uses to tell the marks inside it what is happening.
 * The control tracks the pointer; the mark only reacts. That way the whole
 * button is live, not just the 14px glyph in its middle.
 */
export type IconState = 'rest' | 'hover' | 'press' | 'on' | 'live'

export const IconStateContext = createContext<IconState>('rest')
